(ns frontend.view.modals.account-reactivate.view
  (:require
   [common.email :as email]
   [common.localization :as loc]
   [common.roles :as roles]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.modals.account-reactivate.events :as events]
   [frontend.view.modals.components.processing-modal :as processing-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.notification.view :as notification-modal]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.components.radio-group.view :as radio-group]))

(defonce modal-key :account-reactivate)

(defn not-unique-email?
  [existing-accounts email]
  (let [lc (fu/trimmed-lower-case email)]
    (contains? (->> existing-accounts
                    (map :account/email)
                    (map fu/trimmed-lower-case)
                    (set))
               lc)))

(defn view-body
  [state allow-email-edit? other-accounts-lcase-emails role-kw]
  (let [options (->> [:role/user :role/admin]
                     (map (fn [p]
                            {:value   p
                             :content (loc/tr p)})))]
    [:div
     {:class "flex flex-column gap-4"}
     [labelled-input/view
      {:label (loc/tr :tenant-users/first-name)
       :data-type :data.type/text-simple
       :value     (get @state :first-name)
       :on-change (fn [new-value]
                    (swap! state assoc :first-name new-value))}]
     [labelled-input/view
      {:label (loc/tr :tenant-users/last-name)
       :data-type :data.type/text-simple
       :value     (get @state :last-name)
       :on-change (fn [new-value]
                    (swap! state assoc :last-name new-value))}]
     [:div
      [labelled-input/view
       {:label (loc/tr :tenant-users/email)
        :data-type :data.type/text-simple
        :disabled? (not allow-email-edit?)
        :value     (get @state :email)
        :on-change (fn [new-value]
                     (swap! state assoc :email new-value))}]
      [:p {:class "text-xs"}
       (cond
         (empty? (fu/trimmed-lower-case (get @state :email)))
         (loc/tr :error-field-not-clearable [(loc/tr :email)])

         (not (email/valid-email-pattern? (get @state :email)))
         (loc/tr :account-email-not-valid)

         (some #{(fu/trimmed-lower-case (get @state :email))} other-accounts-lcase-emails)
         (loc/tr :email-exists-on-other-account))]]
     (when-not (roles/is-guest-role? role-kw)
       [:div
        [:div
         {:class "pb-2 text-[14px] text-input-light-text font-semibold"}
         (loc/tr :role) false]
        [radio-group/radio-group-v2
         {:checked   (:role-kw @state)
          :orientation :vertical
          :on-change (fn [value]
                       (swap! state assoc :role-kw value))}
         options]])]))

(defn footer-view
  [edit? state on-close! account role button-text on-submit!]
  (let [ready? (events/form-ready? state account (:role/role role))
        no-changes? (not (events/unsaved-changes? state account (:role/role role)))]
    [:div
     {:class "ml-auto"}
     [modal/right-single-button
      nil
      (or (not ready?)
          (and edit?
               no-changes?))
      (fn [_]
        (let [reactivate! (fn [send-email?]
                            (events/re-activate-account!
                             state
                             (:db/id account)
                             (:db/id role)
                             send-email?
                             on-close!
                             on-submit!))]
          (if (or (not (:email @state))
                  (= (:email @state) (:account/email account)))
            (reactivate! true)
            (modals/open-modal! notification-modal/modal-key
                                {:title              (loc/tr :attention)
                                 :body-text          (loc/tr :you-changed-account-email-notification)
                                 :ok-button-text     (loc/tr :yes)
                                 :cancel-button-text (loc/tr :no)
                                 :on-cancel!         (partial reactivate! false)
                                 :on-ok!             (partial reactivate! true)}))))
      (or button-text
          (if edit?
            (loc/tr :save)
            (loc/tr :reinvite)))
      nil]]))

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [account-id role-id allow-email-edit? title submit-button-text success-message
                on-submit! on-close!]}
        props
        on-close! (fn []
                    (when on-close!
                      (on-close!))
                    (close-modal!))
        all-accounts @session/all-accounts
        account (->> all-accounts
                     (cu/filter-by :db/id account-id)
                     (first))
        other-accounts (remove #(= account %) all-accounts)
        other-accounts-lcase-emails (->> other-accounts
                                         (map :account/email)
                                         (map fu/trimmed-lower-case))
        role (get @session/entities role-id)
        edit? (not (:common/disabled? role))]
    [processing-modal/render-modal
     {:state             state
      :shown?            (and shown? topmost?)
      :success-text      (or success-message (loc/tr :success-account-reactivated))
      :on-close!         on-close!
      :class-name        class-name
      :on-show!          (fn []
                           (swap! state assoc
                                  :email (:account/email account)
                                  :first-name (:account/first-name account)
                                  :last-name (:account/last-name account)
                                  :role-kw (:role/role role)))
      :default-title-fn  (fn []
                           (or title
                               (loc/tr (if edit?
                                     :reinvite-user
                                     :reinvite-user)
                                   [(:account/email account)])))
      :default-body-fn
      (partial view-body state allow-email-edit? other-accounts-lcase-emails (:role/role role))
      :default-footer-fn (partial footer-view edit? state on-close! account role submit-button-text on-submit!)}]))
